import styled from '@emotion/styled';
import { Grid, Tooltip } from '@mui/material';
import React from 'react';
import { COLOR_MAP } from '../../constants/ColorNames';

type TooltipPropsType = {
  title: string;
  disabled: boolean;
  children: React.ReactElement<any, any>;
}

const ToolTipContainer = styled(Grid)`
  padding: 1.2rem;
  color: ${COLOR_MAP.WHITE};
  background-color: ${COLOR_MAP.LIGHT_GREY};
  border-radius: 0.4rem;
  font-family: NOTO SANS;
`;

const TooltipText = styled.p`
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2.2rem;
  margin: 0;
`;

export const TooltipContent = ({ title }: { title: string }) => {
  return (
  <ToolTipContainer container spacing={'1.2rem'}>
    <TooltipText>{title}</TooltipText>
  </ToolTipContainer>
  )
}

const TooltipCustom = (props: TooltipPropsType) => {
  const { title, disabled=true, children } = props
  return (
    <Tooltip
      title={disabled ? null : <TooltipContent title={title} />} arrow placement="top">
      {children}
    </Tooltip>
  )
}

export default TooltipCustom;